(() => {
  const SAFE = /[^a-zA-Z0-9._-]/g;

  function clean(value, max = 64) {
    return String(value || '')
      .trim()
      .slice(0, max)
      .replace(SAFE, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function pushEvent(name, payload = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  }

  function init(section) {
    if (!section || section.dataset.mimosaInit === 'true') return;
    section.dataset.mimosaInit = 'true';

    if (section.dataset.hideChrome === 'true') {
      document.body.classList.add('mimosa-lead-mode');
    }

    const params = new URLSearchParams(window.location.search);
    const attribution = {
      utm_source: clean(params.get('utm_source')),
      utm_medium: clean(params.get('utm_medium')),
      utm_campaign: clean(params.get('utm_campaign')),
      utm_content: clean(params.get('utm_content')),
      qr_source: clean(params.get('qr_source'))
    };

    try {
      const key = 'mimosa_lead_attribution';
      const hasAttribution = Object.values(attribution).some(Boolean);

      if (hasAttribution) {
        sessionStorage.setItem(key, JSON.stringify(attribution));
      } else {
        const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
        Object.keys(attribution).forEach((k) => {
          attribution[k] = clean(saved[k]);
        });
      }
    } catch (_) {}

    pushEvent('mimosa_lead_view', {
      lead_source: attribution.qr_source || attribution.utm_source || 'direct',
      lead_campaign: attribution.utm_campaign || ''
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mimosa-lead]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-mimosa-lead]'));
  });
})();